export enum OrderDeliveryStatusEnum {
  /**
   * Заявка на доставку создана
   */
  NEW = 'NEW',
  /**
   * Оценка заявки на доставку
   */
  REQUSET_ESTIMATING = 'REQUSET_ESTIMATING',
  /**
   * Заявка на доставку подтверждена
   */
  REQUEST_ACCEPTED = 'REQUEST_ACCEPTED',
  /**
   * Поиск курьера
   */
  COURIER_SEARCH = 'COURIER_SEARCH',
  /**
   * Курьер найден
   */
  COURIER_FOUND = 'COURIER_FOUND',
  /**
   * Курьер ожидает заказ
   */
  COURIER_WAITING_ORDER = 'COURIER_WAITING_ORDER',
  /**
   * Курьер забрал заказ
   */
  COURIER_PICKUPED_ORDER = 'COURIER_PICKUPED_ORDER',
  /**
   * Курьер на месте
   */
  COURIER_ARRIVED = 'COURIER_ARRIVED',
  /**
   * Курьер ожидает оплаты
   */
  COURIER_PAY_WAITING = 'COURIER_PAY_WAITING',
  /**
   * Заказ доставлен
   */
  DELIVERED = 'DELIVERED',
  /**
   * Курьер возвращает заказ
   */
  COURIER_RETURNING = 'COURIER_RETURNING',
  /**
   * Заказ возвращён
   */
  RETURNED = 'RETURNED',
  /**
   * Отменен курьером
   */
  CANCELED_BY_CURIER = 'CANCELED_BY_CURIER',
  /**
   * Отменен бесплатно
   */
  CANCELED_FREE = 'CANCELED_FREE',
  /**
   * Отменен платно с возвратом заказа
   */
  CANCELED_PAID_WITH_RETURN = 'CANCELED_PAID_WITH_RETURN',
  /**
   * Отменен платно без возврата заказа
   */
  CANCELED_PAID_WITH_NO_RETURN = 'CANCELED_PAID_WITH_NO_RETURN',
  /**
   * Курьер не найден
   */
  CURIER_NOT_FOUND = 'CURIER_NOT_FOUND',
  /**
   * Заявка на доставку не сформирована
   */
  REQUSET_ESTIMATING_FAILED = 'REQUSET_ESTIMATING_FAILED',
  /**
   * Неизвестная ошибка
   */
  FAILED = 'FAILED',
  /**
   * Неизвестно
   */
  UNKNOWN = 'UNKNOWN',
}
